// 結合
const API_GATEWAY = "https://dev-api.iot.leadsecurity.co.jp";
// 検証
//const API_GATEWAY = "https://stg-api.iot.leadsecurity.co.jp";
// 商用
//const API_GATEWAY = "https://api.iot.leadsecurity.co.jp";
export default API_GATEWAY;
